<template>
  <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 143 25" width="143" height="25">
    <path style="fill: #ffffff" d="m7.5 25c0-13.8 11.2-25 25-25h78c13.8 0 25 11.2 25 25v5c0 13.8-11.2 25-25 25h-78c-13.8 0-25-11.2-25-25z"/>
    <path fill-rule="evenodd" style="fill: #ffffff" d="m134 17c0 0 1.5 4 3.5 5.5 2 1.5 5.5 2.5 5.5 2.5h-7.5z"/>
    <path fill-rule="evenodd" style="fill: #ffffff" d="m9 17c0 0-1.5 4-3.5 5.5-2 1.5-5.5 2.5-5.5 2.5h7.5z"/>
  </svg>
</template>